import { NamedProperty } from "sprint-common-web";

import { ContentSubtype } from "./ContentSubtype";
import { isTrailerVersionType } from "./TrailerContentVersion";

export enum EncodeSpecificationContentType {
    Movie = 1,
    TvSingle = 2,
    FeatureDocumentary = 3,
    ShortFilm = 4,
    TvSeries = 5,
    Advert = 6,
    Promo = 7,
    Safety = 8,
    IndentWarning = 9,
    ClientSpecific = 10,
    Trailer = 11
}

const ContentSubtypeToEncodeSpecificationContentTypeMap: Record<ContentSubtype, EncodeSpecificationContentType> = {
    [ContentSubtype.Movie]: EncodeSpecificationContentType.Movie,
    [ContentSubtype.TvSingle]: EncodeSpecificationContentType.TvSingle,
    [ContentSubtype.FeatureDocumentary]: EncodeSpecificationContentType.FeatureDocumentary,
    [ContentSubtype.ShortFilm]: EncodeSpecificationContentType.ShortFilm,
    [ContentSubtype.TV]: EncodeSpecificationContentType.TvSeries,
    [ContentSubtype.Advert]: EncodeSpecificationContentType.Advert,
    [ContentSubtype.Promo]: EncodeSpecificationContentType.Promo,
    [ContentSubtype.Safety]: EncodeSpecificationContentType.Safety,
    [ContentSubtype.IndentWarning]: EncodeSpecificationContentType.IndentWarning,
    [ContentSubtype.ClientSpecific]: EncodeSpecificationContentType.ClientSpecific
};

export const mapContentToEncodeSpecificationContentType = ({
    contentSubtype,
    contentVersionType
}: {
    contentSubtype: ContentSubtype;
    contentVersionType?: NamedProperty;
}): EncodeSpecificationContentType => {
    if (isTrailerVersionType(contentVersionType)) {
        return EncodeSpecificationContentType.Trailer;
    }

    return ContentSubtypeToEncodeSpecificationContentTypeMap[contentSubtype];
};
